
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IViewMetadata } from "@tylertech/tyler-api-types";

/**
 * DashboardMetadataService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class DashboardMetadataService {
    private readonly $apiService = inject(ApiService);
    
    GetDashboardMetadataView(): Promise<IViewMetadata> {
        return this.$apiService.sendAuth("IDashboardMetadataService/GetDashboardMetadataView");
    }
}
